import { toyCategories } from "@/mocks/homeData";

export default function CategorySection() {
  return (
    <section id="category" className="w-full py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        {/* Section Title */}
        <div className="flex items-center gap-2 mb-6 md:mb-8">
          <i className="ri-search-2-line text-accent-500 text-lg"></i>
          <h2 className="text-lg md:text-xl font-bold text-foreground-950">
            何を探していますか？
          </h2>
        </div>

        {/* Category Cards */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-7 gap-3 md:gap-4">
          {toyCategories.map((cat) => (
            <a
              key={cat.id}
              href={`#${cat.id}`}
              className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl bg-white border border-background-200 hover:border-primary-300 hover:shadow-sm transition-all"
            >
              <div
                className={`w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center ${cat.color}`}
              >
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 text-center group-hover:text-primary-500 transition-colors">
                {cat.label}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}